import React from 'react';
import BookCover from './BookCover';
import BookContent from './BookContent';

const BookItem = ({ book, index }) => {
  const isReversed = index % 2 === 1;
  
  return (
    <div className={`${book.bgColor} rounded-3xl p-8 md:p-12`}>
      <div className={`grid md:grid-cols-2 gap-12 items-center ${isReversed ? 'md:flex-row-reverse' : ''}`}>
        <div className={isReversed ? 'md:order-2' : 'md:order-1'}>
          <BookCover book={book} />
        </div>
        
        <div className={isReversed ? 'md:order-1' : 'md:order-2'}>
          <BookContent book={book} />
        </div>
      </div>
    </div>
  );
};

export default BookItem;
